var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarToggleCloseDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 19,
    viewBox: "0 0 29 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0184 9.90601H7.98074C7.68377 9.90601 7.4375 9.65974 7.4375 9.36277C7.4375 9.0658 7.68377 8.81953 7.98074 8.81953H21.0184C21.3154 8.81953 21.5617 9.0658 21.5617 9.36277C21.5617 9.65974 21.3154 9.90601 21.0184 9.90601Z",
    fill: "#E9ECEF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56836 12.5929C3.02983 8.94842 7.8287 1.64826 15.3324 1.60386C22.8361 1.55946 26.5251 1.58536 27.4316 1.60386",
    stroke: "#E9ECEF",
    strokeWidth: 1.61593,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4316 6.40706C25.9702 10.0516 21.1713 17.3517 13.6676 17.3961C6.16388 17.4405 2.47494 17.4146 1.56843 17.3961",
    stroke: "#E9ECEF",
    strokeWidth: 1.61593,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarToggleCloseDark);
export default __webpack_public_path__ + "static/media/sidebar-toggle-close-dark.8f8f9b6231b9e5f9e9fcd849fc910f39.svg";
export { ForwardRef as ReactComponent };